/* eslint-disable react/no-unknown-property */
import React, { useContext } from 'react'

import { defaultToEmptyString } from '../../../assets/ts/formatting/formatting'
import { UserContext } from '../../../store/user-context-provider'

interface Props {
  bgcNum
  key: number
  kpi
  parentKPI
  setKpiName
  updateKpiFilter: (e) => void
}
const MediumKPI = ({ bgcNum, key, kpi, parentKPI, setKpiName, updateKpiFilter }: Props) => {
  const userContext = useContext(UserContext)
  const currentUser = userContext?.me?.rid ?? ''
  const handleNeedToWork = (parentKPI, sectionCode, updateKpiFilter) => {
    if (parentKPI.toLowerCase() === 'assigned to me') {
      updateKpiFilter({
        activeFilter: true,
        assignedToMe: currentUser,
        assignedToOther: null,
        customerActionRequiredFilter: null,
        isCPOwnerOrLeadership: null,
        isResponsePending: undefined,
        isResponseRequired: undefined,
        needToWorkFilter: true,
        pendingActionOutsideFilter: null,
        sectionCodeKPIFilter: sectionCode,
        statusCodeFilter: '',
        unassignedFilter: null,
      })
    }
    if (parentKPI.toLowerCase() === 'assigned to others') {
      updateKpiFilter({
        activeFilter: true,
        assignedToMe: null,
        assignedToOther:currentUser ,
        currentSection:undefined,
        customerActionRequiredFilter: null,
        elevatedToMPF: null,
        isCPOwnerOrLeadership:null,
        isResponsePending: undefined,
        isResponseRequired: undefined,
        needToWorkFilter:true,
        pendingActionOutsideFilter: null,
        returnedFromMPF: null,
        sectionCodeFilter: sectionCode,
        statusCodeFilter:'',
        unassignedFilter: null
      })
    }
  }
  const handleCAR = (parentKPI, sectionCode, updateKpiFilter) => {
    if (parentKPI.toLowerCase() === 'assigned to me') {
      updateKpiFilter({
        activeFilter: true,
        assignedToMe: currentUser,
        assignedToOther: null,
        customerActionRequiredFilter: true,
        isCPOwnerOrLeadership: undefined,
        isResponsePending: undefined,
        isResponseRequired: undefined,
        needToWorkFilter: null,
        pendingActionOutsideFilter: false,
        sectionCodeKPIFilter: sectionCode,
        statusCodeFilter: '',
        unassignedFilter: null,
      })
    }
    if (parentKPI.toLowerCase() === 'assigned to others') {
      updateKpiFilter({
        activeFilter: true,
        assignedToMe: null,
        assignedToOther: currentUser,
        customerActionRequiredFilter: true,
        isCPOwnerOrLeadership: undefined,
        isResponsePending: undefined,
        isResponseRequired: undefined,
        needToWorkFilter: null,
        pendingActionOutsideFilter: false,
        sectionCodeKPIFilter: sectionCode,
        statusCodeFilter: '',
        unassignedFilter: null,
      })
    }
  }
  const handlePAO = (parentKPI, sectionCode, updateKpiFilter) => {
    if (parentKPI.toLowerCase() === 'assigned to me') {
      updateKpiFilter({
        activeFilter: true,
        assignedToMe: currentUser,
        assignedToOther: null,
        customerActionRequiredFilter: false,
        isCPOwnerOrLeadership: undefined,
        isResponsePending: undefined,
        isResponseRequired: undefined,
        needToWorkFilter: null,
        pendingActionOutsideFilter: true,
        sectionCodeKPIFilter: sectionCode,
        statusCodeFilter: '',
        unassignedFilter: null,
      })
    }
    if (parentKPI.toLowerCase() === 'assigned to others') {
      updateKpiFilter({
        activeFilter: true,
        assignedToMe: null,
        assignedToOther: currentUser,
        customerActionRequiredFilter: false,
        isCPOwnerOrLeadership: undefined,
        isResponsePending: undefined,
        isResponseRequired: undefined,
        needToWorkFilter: null,
        pendingActionOutsideFilter: true,
        sectionCodeKPIFilter: sectionCode,
        statusCodeFilter: '',
        unassignedFilter: null,
      })
    }
  }

  const handleKPIUpdate = (parentKPI, kpi, updateKpiFilter, currentUser) => {
    const { sectionCode, title } = kpi
    if (!updateKpiFilter) return
    setKpiName(title)
    const KPIs = {
      'customer action required': handleCAR,
      'need to work': handleNeedToWork,
      'pending action outside cp': handlePAO,
    }

    const handleKPI = KPIs[title.toLowerCase()]

    if (handleKPI) {
      handleKPI(parentKPI, sectionCode, updateKpiFilter)
    } else {
      console.warn(`No handler found for kpi title: ${title}`)
    }
  }
  return (
    <div className='bordered2 border-radius w-100 my-2' key={key}>
      <a
        aria-live='polite'
        className='p-0 align-items-center p-relative text-decoration-none d-flex flex-row w-100 kpiborder border-radius'
        onClick={() => handleKPIUpdate(parentKPI, kpi, updateKpiFilter, currentUser)}
        status-kpis={kpi.colorcode}
        style={{ pointerEvents: kpi.count === '00' ? 'none' : 'auto' }}
        tabIndex={0}
        title={kpi.title}
      >
        <span className='font-11  poppins-semibold  text-uppercase px-2'>{defaultToEmptyString(kpi.title)}</span>
        <span
          className={`font-12 poppins-bold ms-auto px-3 py-2 bgcolor-${bgcNum} poppins-bold font-16 m--1 border-top-right-radius border-bottom-right-radius`}
        >
          {defaultToEmptyString(kpi.count)}
        </span>
      </a>
    </div>
  )
}

export default MediumKPI
